import { CryptoRepository, MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$rootScope', 'Util'];

class CryptoWalletController {

    constructor($scope, $state, $rootScope, Util) {

        $scope.currency = $rootScope.cryptoCurrency;
        const user = MeRepository.getMyUser();
        $scope.tfaValidationStep = user.attributes.status_tfa === 'active' ? 'tfaEnabled' : 'tfaDisabled';
        const dateTFAactivated = user.attributes.date_tfa_activated;
        $scope.customToFixed = Util.toFixed;

        const getDateDifference = (date) => {

            const now = moment();
            const end = moment(date);
            const duration = moment.duration(now.diff(end));
            const days = Util.toFixed(duration.asHours(), 2);
            return days;

        };

        if (dateTFAactivated) {

            if (parseFloat(getDateDifference(dateTFAactivated)) > 24) {

                $scope.showWithdrawButton = true;
                $scope.showTimeNotification = false;

            } else {

                $scope.showWithdrawButton = false;
                $scope.showTimeNotification = true;

            }

        } else if (!dateTFAactivated && $scope.tfaValidationStep === 'tfaEnabled') {

            $scope.showWithdrawButton = true;

        }

        $scope.changeCurrency = (currency) => {

            $scope.currency = currency;
            $rootScope.cryptoCurrency = $scope.currency;
            localStorage.setItem('CryptoCurrency', $scope.currency);

            $scope.ethPrice =
                Util.toFixed($scope.prices.conversionRateMap[$scope.currency], 2);
            $scope.getBalances($scope.wallets);

        };

        $scope.connectCoinbase = () => {

            Mixpanel.send('ConnectWeb Crypto Click', {
                Label: 'Withdraw',
            });

            $state.go('root.dashboard.crypto.ltb', {
                ltb: 'coinbase-account',
            });

        };

        // Calculate overall Balances
        $scope.getBalances = (data) => {

            const cryptoCurrencies = [];
            let moneyBalance = 0;
            let cryptoBalance = 0;
            Object.keys(data).forEach((key) => {

                moneyBalance +=
                $scope.prices.conversionRateMap[$scope.currency] *
                data[key].balance;
                cryptoBalance += data[key].balance;
                cryptoCurrencies.push(key);

            });

            $scope.moneyBalance = `${Util.toFixed(moneyBalance, 2)}`;
            $rootScope.moneyBalance = $scope.moneyBalance;
            $scope.cryptoBalance = `${Util.toFixed(cryptoBalance, 6)}`;
            $rootScope.cryptoBalance = $scope.cryptoBalance;
            $scope.cryptoCurrencies = cryptoCurrencies;

        };

        $scope.updateWallet = () => {

            $scope.wallets = CryptoRepository.getAll('wallets') || {};
            $scope.prices = CryptoRepository.getAll('prices') || {};
            if ($scope.prices.conversionRateMap) {

                $scope.currencies = Object.keys($scope.prices.conversionRateMap).sort();
                $scope.ethPrice =
                    Util.toFixed($scope.prices.conversionRateMap[$scope.currency], 2);

            }

            if (Object.keys($scope.wallets).length > 0) {

                $scope.getBalances($scope.wallets);

            }

        };

        $scope.updateWallet();

        const onCryptoDataNext = () => {

            $scope.updateWallet();

        };

        this.cryptoRepository = CryptoRepository.getObservable();
        this.cryptoSubscriber = this.cryptoRepository
            .subscribe(
                data => onCryptoDataNext(data),
                () => { },
                () => { },
            );

        $scope.goToTFA = () => {

            $rootScope.isComingFromCrypto = true;

        };

    }

}


class CryptoWalletDirective {

    constructor() {

        this.template = require('./crypto-wallet.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $state, $rootScope, Util) =>
            new CryptoWalletController($scope, $state, $rootScope, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'CryptoWalletCtrl';

    }

}

_directiveDependencies.push(() => new CryptoWalletDirective());


angular.module('directives')
    .directive('cryptoWallet', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/crypto-wallet/crypto-wallet.js